/**
 * 创建人：但志强
 * 时间：2019-6-11
 * 描述：登录页面
 * 更新记录: 
 */
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { SwJwtService } from '../librarys/serves/sw-jwt.service';
import { SwRouteguardService } from '../librarys/serves/sw-routeguard.service';
import { SwMenuService } from '../librarys/serves/sw-menu.service';
import { environment } from 'src/environments/environment';
import { SwLoadingmaskComponent } from '../librarys/components/basic-components/sw-loadingmask/sw-loadingmask.component';
import { Md5 } from "ts-md5";
import { SwHttpClientService } from '../librarys/serves/sw-http-client.service';
import { ConfigurationService } from '../librarys/serves/public/configuration.service';
import { OninitService } from '../librarys/serves/oninit.service';
import { SwMassageBoxService } from '../librarys/serves/sw-massage-box.service';
import { SwLoadingmaskService } from '../librarys/components/basic-components/sw-loadingmask/sw-loadingmask.service';
import {TranslateService} from '@ngx-translate/core';
import { SystemIdService } from '../librarys/serves/public/system-id.service';
import { ActivationEnd, NavigationEnd, Router } from '@angular/router';
import { LoginStatusService } from '../librarys/serves/login-status.service';

declare var $: any;
@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit,AfterViewInit {
  msg: string = "";
  loginSystem: string = "";
  loginImage:string = ''
  projectLogo: string = "";
  // projectLogoWidth: string = "";
  copyRight:string = '';//版权信息
  systemData:any=[];
  partnerData:any=[];
  loginStyle = environment.loginStyle;
  multiTenancy:boolean; //是否开启多租户管理模式
  closeEye: boolean = true;
  enableSsoLogin:boolean =environment.enableSsoLogin; //是否启用sso登录

  defualtlanguage:string='zh-CN';//默认语言
  languages:any = [{id:'zh-CN',text:'中文简体'},{id:'en-US',text:'English'}] //所有语言
  isLanguage:boolean = false; //是否使用切换语言
  isVcode:boolean = true; //是否有验证码功能
  isSlideVerify:boolean = false; //滑动验证码是否通过；默认为false，未通过；true通过
  isSliderCode: boolean = false; //登录界面是否有滑动验证功能,默认不需要滑动验证,值为false
  hasLogin:boolean = false  //是否已经登录
  asideMenuSubscriptiona:any  //是否已登录的状态订阅
  differentSites:boolean = false  //是否分站点部署不同模块
  customerName = environment.customerName;
  constructor(
    private _http: SwHttpClientService,
    private init :OninitService,
    private jwt: SwJwtService,
    private config: ConfigurationService, //初始化配置文件
    private swMenus: SwMenuService,
    private box: SwMassageBoxService,  //消息提示服务
    private swRouter: SwRouteguardService,
    private systemId:SystemIdService,
    private swLoadingmaskService:SwLoadingmaskService,  //过渡效果
    public translateService: TranslateService,
    private router: Router,
    private loginStatusService : LoginStatusService
    ) {
        this.defualtlanguage = environment.defaultLanguage
        if(environment.defaultLanguage){
          this.isLanguage = true;
        }
        this.isSliderCode = environment.isSliderCode
        

        this.router.events.subscribe((event: NavigationEnd) => {
          if (event instanceof ActivationEnd) {
            let param = event.snapshot["queryParams"]
            
            if (param && param['token'] && environment["enableModuleDeploy"]) {
              this.hasLogin = true
              
             //  this.login1(param['token'], param['systemId'])
              this.login1(param['token'], param['systemId'],param['functionCode'],param['RedirectUrl'],param['queryParams'])
            }
          }
        });
     }

  LoginModel: any = {
    loginName: '',
    systemCode:'',
    loginPassword: '',
    vcode:'',
    partnerCode: ''
  };
  @ViewChild("loading") loading: SwLoadingmaskComponent;
  
  login1(jwt, systemId,functionCode,RedirectUrl,queryParams) {
    // this.Jwt.setlocaToken("token", data["data"]["jwt"]); //添加新的token
    this.jwt.setToKen("token", jwt); //添加新的token
    this.jwt.removeItem("TabMenu"); //添加新的工作台
    this.jwt.setToKen("systemId", systemId);
    this.swMenus.location('login',functionCode,RedirectUrl,queryParams);
    this.swMenus.valueUpdated.subscribe(val => { 
      if (!val) {  //菜单获取失败,还在登陆页面,就要更新验证码
        this.getimg();
      }
    })
  }
  
  ngOnInit() {
    //如果是soo登录，执行以下步骤
    if(environment.enableSsoLogin){   
      let systemId = this.systemId.getSystemId();
      let code=this.getQueryVariable("code");
      if(code){
        //存在则先请求一次带code的请求头，拿到token
         let headers= {
          'Content-Type' :'application/json',
          'Accept':'application/json',
          'code':code
          }
        this._http.Post(environment.seekerWebAPI + "sw/init?systemId=" + systemId, {},headers).subscribe(data=>{

        });
      }else{
        //不存在说明没有进行过sso登陆
        this._http.Post(environment.seekerWebAPI + "sw/init?systemId=" + systemId, {}).subscribe(data=>{

        });
      }
      return false;
    }
    if(!this.hasLogin){
      this.multiTenancy = environment.multiTenancy
      this.location()
      this.getimg();
      //获取当前语言
      if(this.translateService.currentLang){
        this.defualtlanguage=this.translateService.currentLang;
      }
    }
  }
  ngAfterViewInit(): void {
     //初始化滑动模块验证功能
     if(!this.hasLogin){
      this.initSlideVerify()
     }

     this.asideMenuSubscriptiona = this.loginStatusService.loginStatusUpdated.subscribe(val=>{
       this.hasLogin = false
       this.multiTenancy = environment.multiTenancy
       this.location()
       this.getimg();
       //获取当前语言
       if(this.translateService.currentLang){
         this.defualtlanguage=this.translateService.currentLang;
       }
     
     })
  }
  getQueryVariable(variable)
  {
    try{
      var query = window.location.hash.split("?")[1];
      var vars = query.split("&");
      for (var i=0;i<vars.length;i++) {
              var pair = vars[i].split("=");
              if(pair[0] == variable){return pair[1];}
      }
      return(false);
    }catch{
      return(false);
    }     
  }
  //
  //滑动验证初始化
  initSlideVerify(){
    let that = this
    this.isSlideVerify = false
    $('#mpanel1').empty();
    $('#mpanel1').slideVerify({
     type : 1,		//类型
     vOffset : 3,	//误差量
     barSize : {
       width : '100%',
       height : '38px',
     },
     language:this.defualtlanguage,
     ready : function() {
     },
     success : function() {
      that.isSlideVerify = true
     },
     error : function() {
     }
     
   });
 }
  //密码切换眼睛功能
  clickEye() {
    this.closeEye = !this.closeEye;
  }
  enterKeyword(event){
    let str = event.target.value
    //包含大小写字母、数字和特殊字符，至少8位
    var reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[1-9])(?=.*[\W]).{8,}$/
  }
  onSubmit({ value, valid }, event: Event) {
    this.msg = "";
     //包含大小写字母、数字和特殊字符，至少8位
    // let reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[1-9])(?=.*[\W]).{8,}$/
    // if(!reg.test(value.loginPassword)){
    //   this.msg = '密码在8位以上、含大小写、数字、特殊字符'
    //   return
    // }
    if (valid) {
      //登陆先打开loading遮罩层 
      //登陆先打开loading遮罩层
      this.swLoadingmaskService.openLoading()
      let pwd = Md5.hashStr(value.loginPassword);
      //在这要替换掉特殊字符串,不然会出现BUG
      value.loginName=value.loginName.replace('&','%26');
      if(value.vcode){
        value.vcode=value.vcode.replace('&','%26');
      }

      // partnerCode
      if(!environment.multiTenancy){
        value.systemCode = environment.systemCode
      }
     
        //二次加密loginPassword
      let pwdvid:any; //二次加密后的密码
     
      if(value.vid){
        //有验证码的情况下：
       
        //先转换成大写 
        let uperPwd=pwd.toString().toLocaleUpperCase();
        let uperVid = value.vid.toLocaleUpperCase();
        pwdvid = Md5.hashStr(uperPwd+uperVid);

        let path  = environment.seekerWebAPI + "sw/login?loginName=" + value.loginName + "&loginPassword=" + pwd + "&systemCode=" + value.systemCode;
        if(environment.encryptedPassword==true){
          //需要加密
          path  = environment.seekerWebAPI + "sw/login?loginName=" + value.loginName + "&loginPassword=" + pwdvid + "&systemCode=" + value.systemCode;
        }

       
        let parms={
          loginName: value.loginName,
          loginPassword:pwd,
          systemCode:value.systemCode,
          vcode:value.vcode,
          vid:value.vid,
          partnerCode:null
        }
  
        if(this.LoginModel.partnerCode){
          path  = environment.seekerWebAPI + "sw/login?loginName=" + value.loginName + "&loginPassword=" + pwd + "&systemCode=" + value.systemCode+"&partnerCode="+value.partnerCode
          if(environment.encryptedPassword==true){
            //需要加密
            path  = environment.seekerWebAPI + "sw/login?loginName=" + value.loginName + "&loginPassword=" + pwdvid + "&systemCode=" + value.systemCode+"&partnerCode="+value.partnerCode
          }
          parms.partnerCode=value.partnerCode;
        }
        path +="&vcode="+value.vcode +"&vid="+value.vid;
  
        this.entryLogin(path,true)

      }else{
        //无验证码的情况下，先获得验证码再加密：
       
        this._http.Post(environment.seekerWebAPI+"sw/queryVCode",{}).subscribe(data=>{
          if(data["code"]==200){
            let uperPwd=pwd.toString().toLocaleUpperCase();
            let vid=data["data"]["vid"].toString().toLocaleUpperCase();
             pwdvid = Md5.hashStr(uperPwd+vid);

             let path  = environment.seekerWebAPI + "sw/login?loginName=" + value.loginName + "&loginPassword=" + pwd + "&systemCode=" + value.systemCode;
             if(environment.encryptedPassword==true){
              //需要加密
              path  = environment.seekerWebAPI + "sw/login?loginName=" + value.loginName + "&loginPassword=" + pwdvid + "&systemCode=" + value.systemCode;
            }

             let parms={
               loginName: value.loginName,
               loginPassword:pwd,
               systemCode:value.systemCode,
               vcode:value.vcode,
               vid:value.vid,
               partnerCode:null
             }
       
             if(this.LoginModel.partnerCode){
               path  = environment.seekerWebAPI + "sw/login?loginName=" + value.loginName + "&loginPassword=" + pwd + "&systemCode=" + value.systemCode+"&partnerCode="+value.partnerCode
              
               if(environment.encryptedPassword==true){
                //需要加密
                path  = environment.seekerWebAPI + "sw/login?loginName=" + value.loginName + "&loginPassword=" + pwdvid + "&systemCode=" + value.systemCode+"&partnerCode="+value.partnerCode
              }
               parms.partnerCode=value.partnerCode;
             }
             path +="&vid="+data["data"]["vid"];
       
             this.entryLogin(path,false)

          }else{
            this.box.waring(data.msg);
            this.swLoadingmaskService.closeLoading()
          }
      })
      }
    }
  }

  //登录接口
  entryLogin(path,isVid){
    this._http.Post(path, null).subscribe(
      data => {
       if (data["code"] == 200) {
         if(this.LoginModel.partnerCode){
           window.open("http://www.baidu.com","_self")
           return;
         }
         
         this.init.GC(); // 清除缓存，工作台和路由复用
         // this.Jwt.setlocaToken("token", data["data"]["jwt"]); //添加新的token
         this.jwt.setToKen("language",this.defualtlanguage); //登录成功后将当前语言设置存进缓存

         this.jwt.setToKen("token", data["data"]["authorizationu"]); //添加新的token
         this.jwt.removeItem("TabMenu"); //添加新的工作台
         this.jwt.setToKen("systemId", data["data"]["systemId"]);
         this.swMenus.location('login');
         //密码过期提醒
         if(data["data"]["expire"]){
           this.box.danger(data["data"]["expire"]);
         }            
         this.swMenus.valueUpdated.subscribe(val => {
           if(!val){  //菜单获取失败,还在登陆页面,就要更新验证码
            if(isVid){
              this.getimg();
            }
            
           } 
         })

         
       } else if (data["msg"]) {
         this.swLoadingmaskService.closeLoading()
         if(isVid){
          this.getimg();
         }  //重新获取验证码
         this.LoginModel.vcode = ''  //验证码输入框清空
         this.msg = data["msg"];
         this.initSlideVerify()
       }
     }
   )
  }
  location(){
    // this.config.inItConfig();
    // this.inItConfig();
    //如果是多租户,采取获取登录页面系统下拉框列表
    if(this.multiTenancy){
      this.getSystemData();
    }
    this.initValue();
  }

  //初始值
  initValue() { 
   this.loginSystem = environment.projectName;
   this.copyRight = environment.coptyRight;
   this.loginImage = environment.loginBackGround;
   this.projectLogo = environment.projectLogo;
  //  this.projectLogoWidth = environment.projectLogoWidth;
   this.isVcode = environment.isVcode;
  }

  clickdianji() {
    $.support.transition = true
  }

  getPartner(systemCode){
    this.partnerData = [];
    this.LoginModel.partnerCode= ''
    let sysetem = this.systemData.find(x=>x.systemCode == systemCode);
    this._http.Get( environment.seekerWebAPI+"sw/queryPartnersBySystemId?systemId="+sysetem.systemId,{}).subscribe(
      data => {
        if (data["code"] == 200) { 
          this.partnerData = data["data"]
        }
      }
    )
  }
  //初始化配置文件
  inItConfig(){
    try{
      if(this.config.config){
        this.loginSystem = this.config.config.find(x=>x.configKey =="SYS_PROJECT_NAME").configValue;
        let image =  this.config.config.find(x=>x.configKey =="SYS_LOGIN_BACKGROUND").configValue;
        // this.loginImage = "url("+image+") no-repeat center/cover;"
        this.copyRight = this.config.config.find(x=>x.configKey =="SYS_COPYRIGHT_STATE").configValue;
      }else{
        this.config.configpdated.subscribe(data=>{
          this.loginSystem = data.find(x=>x.configKey =="SYS_PROJECT_NAME").configValue;
          let image =  data.find(x=>x.configKey =="SYS_LOGIN_BACKGROUND").configValue;
          // this.loginImage = "url("+image+")  no-repeat center/cover"
          this.copyRight = data.find(x=>x.configKey =="SYS_COPYRIGHT_STATE").configValue;
        })
      }
    }catch(e){}
  }

  getSystemData(){
    //请求数据
    this._http.Post( environment.seekerWebAPI+"sw/querySystems",{}).subscribe(
      data => {
        if (data["code"] == 200) { 
          this.systemData = data["data"]
        }
   
      }
    )
  }


  img:string="";

  getimg(){
    // this._http.Post(environment.seekerWebAPI+"sw/queryVCode",{}).subscribe(data=>{
    //     if(data["code"]==200){
    //       this.img = "data:image/jpeg;base64,"+ data["data"]["image"];
    //       this.LoginModel.vid  = data["data"]["vid"]
    //     }
    // })
  }

  //输入用户名的时候直接将 ` 全部替换成空字符串,否则会直接报错400 Bad Request
  enterName(event){
    if(event.key == '`'){
      this.LoginModel.loginName = event.target.value.replace(/`/g,'')
    }
  }

  //切换语言触发
  // changeEnter(event){
  //   this.defualtlanguage=event.target.value;
  //   this.translateService.use(event.target.value);
  // }

   //切换语言
   selectLanguage(language){
    this.defualtlanguage = language.id;
    this.translateService.use(language.id);
    this.initSlideVerify()
  }
  //匹配选中的语言
  getLanguageText() {
    let lan = this.languages.filter(item=>item.id == this.defualtlanguage)
    if(lan.length > 0){
      return lan[0].text
    }
   
  }

}






